import { render } from "./TicketState.vue?vue&type=template&id=ff0a4c9c"
import script from "./TicketState.vue?vue&type=script&lang=js"
export * from "./TicketState.vue?vue&type=script&lang=js"

import "./TicketState.vue?vue&type=style&index=0&id=ff0a4c9c&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__